import React, { useCallback, useEffect } from 'react';
import { useStats, useHits } from 'react-instantsearch-hooks-web';

interface Props {
  setNumberOfHits?:any;
  setProductHits?: any;

}
const CustomStats: React.FC<Props> = ({ setNumberOfHits, setProductHits  }) => {
  const { nbHits } = useStats();
  const { hits } = useHits()

  useEffect(() => {
    setNumberOfHits(nbHits);
  }, [nbHits]);
  useEffect(() => {
    if(setProductHits)
    setProductHits(hits);
  }, [hits]);
  return <></>;
};

export default CustomStats;
